import { render, staticRenderFns } from "./NominationSettingsComponent.vue?vue&type=template&id=755be14d&scoped=true"
import script from "./NominationSettingsComponent.vue?vue&type=script&lang=js"
export * from "./NominationSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./NominationSettingsComponent.vue?vue&type=style&index=0&id=755be14d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755be14d",
  null
  
)

export default component.exports